import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next';
import {type ISavedCart} from '../schema';
import {savedCartIsEmpty} from './savedCartIsEmpty';

export const canDownloadSavedCart = (savedCart?: ISavedCart) => {
	if (savedCartIsEmpty(savedCart)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};
